import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css"; // Gunakan path relatif jika alias @ bermasalah
import App from "./App"; // Ubah dari "@/App" menjadi "./App" untuk memastikan file terbaca langsung

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js').then(registration => {
      console.log('SW registered: ', registration);
    }).catch(registrationError => {
      console.log('SW registration failed: ', registrationError);
    });
  });
}